import { render, staticRenderFns } from "./addApplyRoomDiscountType.vue?vue&type=template&id=47a11a71"
import script from "./addApplyRoomDiscountType.vue?vue&type=script&lang=js"
export * from "./addApplyRoomDiscountType.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports